"use strict";
// Copied this implementation from vizportalclient and refactored without underscore
// so that vizclient can consume the DataQualityWarning component that needs url interpolation
Object.defineProperty(exports, "__esModule", { value: true });
exports.interpolateString = void 0;
/**
 * A function to replace tokens in square brackets by the result of corresponding functions. The result
 * is an array containing the chunked original string, and the replacement values.
 *
 * For example, using `{token1: () => 'value1'}` and the base string `'test with [token1]'`, the result
 * will be the array `['test with ', 'value1']`.
 *
 * @param baseString - A string containing tokens surrounded by square brackets
 * @param replacements - a {@link IReplacements} instance where the keys are the tokens, and the values are functions that
 *                       return replacement values
 */
function interpolateString(baseString, replacements) {
    var result = [];
    // Refactored the underscore code out of here using: https://github.com/you-dont-need/You-Dont-Need-Lodash-Underscore
    // generate replacements and order them
    var replacementsInOrder = Object.keys(replacements)
        .map(function (k) { return findInString(baseString, k); }) // find occurrences and flatten them
        .reduce(function (a, b) { return a.concat(b); }, []) // .flatten()
        .filter(function (v) { return v.start >= 0; }) // filter out patterns not present in the string
        .sort(function (a, b) { return (a.start > b.start) ? 1 : ((b.start > a.start) ? -1 : 0); }) // sort by start index
        .map(function (v, i, _) { return replace(v, replacements, i); }); // map found values to their replacement, passing their index
    // iterate through replacements, chunk the base string and add it to the result
    var subStringIndex = 0;
    replacementsInOrder.forEach(function (rep) {
        if (rep.start !== subStringIndex) {
            var subString = baseString.substring(subStringIndex, rep.start);
            var wrapped = subString;
            result.push(wrapped);
        }
        result.push(rep.value);
        subStringIndex = rep.end + 1;
    });
    // if there is a trailing chunk, add it as well
    if (subStringIndex < baseString.length) {
        var lastChunk = baseString.substring(subStringIndex);
        var wrapped = lastChunk;
        result.push(wrapped);
    }
    return result;
}
exports.interpolateString = interpolateString;
/**
 * Find occurrences of a key in the base string.
 * @param baseString - The string to search
 * @param key - the key to replace. Only occurrences surrounded by square brackets are considered
 */
function findInString(baseString, key) {
    var searchStart = -1;
    var result = [];
    var keyWithBrackets = "[" + key + "]";
    var index = -1;
    do {
        index = baseString.indexOf(keyWithBrackets, searchStart);
        var val = {
            start: index,
            end: index + keyWithBrackets.length - 1,
            key: key
        };
        result.push(val);
        searchStart = val.end;
    } while (index > -1);
    return result;
}
/**
 * replace a found value with the corresponding function, passing the index into that function
 * @param foundValue - a value with a key, start, and end indices.
 * @param replacements - a {@link IReplacements} instance containing replacement functions / values
 * @param index - the index of the found value
 */
function replace(foundValue, replacements, index) {
    var rep = replacements[foundValue.key];
    foundValue.value = typeof rep === 'function' ? rep(index) : rep;
    return foundValue;
}
//# sourceMappingURL=StringInterpolation.js.map